import React from 'react'
import {NavLink, useLocation, useNavigate} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { clearLastSpotRoute, setMySpotsQuery } from '../store/slices/savedSpotsSlice'
import MapIcon from '../components/icons/MapIcon'
import LocationIcon from '../components/icons/LocationIcon'
import BellIcon from '../components/icons/BellIcon'
import ProfileIcon from '../components/icons/ProfileIcon'

const MobileNav = () => {
    const location = useLocation();
    const lastSpotRoute = useSelector(state => state.savedSpots.lastSpotRoute);
    const mySpotsPath = lastSpotRoute?.path || '/saved-spots';
    const isMySpotsActive = location.pathname.startsWith('/saved-spots') || location.pathname.startsWith('/location/');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Repeated taps step back: last spot -> My Spots (remembered page) -> My Spots page 1
    const handleMySpotsClick = (e) => {
        if (location.pathname.startsWith('/location/')) {
            e.preventDefault();
            dispatch(clearLastSpotRoute());
            navigate('/saved-spots');
        } else if (location.pathname.startsWith('/saved-spots')) {
            e.preventDefault();
            dispatch(setMySpotsQuery({ page: 1, search: '' }));
            navigate('/saved-spots', { state: { resetAt: Date.now() } });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Full-width/height hit area, no tap delay or highlight flash on mobile
    const tabClass = (isActive) => `flex flex-col gap-1 w-full h-full justify-end pb-2 items-center touch-manipulation select-none [-webkit-tap-highlight-color:transparent] ${isActive ? 'active' : ''}`;

    return(
        <nav className='fixed bottom-0 left-0 h-[60px] border-t border-custom-charcoal w-full bg-custom-dark z-[1000]'>
            {/* No gaps on mobile so every pixel of the bar belongs to a tab */}
            <ul className='w-full h-full flex justify-center text-xs text-center sm:px-5 sm:gap-6'>
                <li className='flex-1 h-full sm:flex-none sm:w-[80px]'>
                    <NavLink 
                        to="/" 
                        className={({isActive}) => tabClass(isActive)}
                    >
                        <div>
                            <MapIcon />
                        </div>
                        <div>Map</div>
                    </NavLink>
                </li>

                <li className='flex-1 h-full sm:flex-none sm:w-[80px]'>
                    <NavLink 
                        to={mySpotsPath} 
                        onClick={handleMySpotsClick}
                        className={tabClass(isMySpotsActive)}
                    >
                        <div>
                            <LocationIcon />
                        </div>
                        <div>My Spots</div>
                    </NavLink>
                </li>

                <li className='flex-1 h-full sm:flex-none sm:w-[80px]'>
                    <NavLink 
                        to="/alerts" 
                        className={({isActive}) => tabClass(isActive)}
                    >
                        <div>
                            <BellIcon />
                        </div>
                        <div>Alerts</div>
                    </NavLink>
                </li> 

                <li className='flex-1 h-full sm:flex-none sm:w-[80px]'>
                    <NavLink 
                        to="/account/overview" 
                        className={({isActive}) => tabClass(isActive)}
                    >
                        <div>
                            <ProfileIcon />
                        </div>
                        <div>Account</div>
                    </NavLink>
                </li>
                
            </ul>
        </nav>
    )
}

export default MobileNav